import React from 'react';

import styles from './index.module.scss';

interface Props {
  children: React.ReactNode;
}

function Section({ children }: Props) {
  return <div className={styles.section}>{children}</div>;
}

export default Section;
